import type { ReactNode } from 'react';
import { FocusScope } from 'radix-ui/internal';

/**
 * Lets the widget's text fields take the keyboard while a modal drawer is open.
 *
 * An open drawer (the contact drawer a call is usually placed from) traps focus
 * inside itself, and the widget floats outside it — so the post-call Notes and
 * the transfer search could be clicked but never typed into. Radix pauses the
 * active focus scope whenever a newer one mounts and resumes it when that one
 * unmounts; this is that newer scope, mounted only while a panel with a text
 * field is on screen. It traps nothing itself and never moves focus, and the
 * drawer's own trap comes back the moment the panel closes.
 *
 * `contents` keeps the wrapper out of the widget's flex layout.
 */
export function TypingFocusScope({ children }: { readonly children: ReactNode }) {
    return (
        <FocusScope.Root
            className="contents"
            onMountAutoFocus={(event) => event.preventDefault()}
            onUnmountAutoFocus={(event) => event.preventDefault()}
        >
            {children}
        </FocusScope.Root>
    );
}
